import React from 'react';
import styled from 'styled-components';
import AlertInfo from '@components/common/alert/AlertInfo';
import { GIButton, Modal } from 'app-components';
import { ModalContextType } from '@contexts/modalContext';

const StyledAlertWrapper = styled.div`
    .gi-alert {
        padding: 10px;
    }
`;

const StyledButton = styled.div`
    .gi-button {
        text-transform: none;
    }
`;

interface IModalProps extends ModalContextType {
    onDeleteHandler: () => void;
}

export default function DeleteDocumentModal({ onDeleteHandler, closeModal }: IModalProps) {
    function onClose() {
        closeModal('deleteDocumentModal');
    }

    return (
        <Modal id="deleteDocumentModal">
            <Modal.Header
                id="deleteDocumentModalHeader"
                titleId="dmi.applicantVerifications.confirmDelete"
                onHide={onClose}
            />
            <Modal.Body id="deleteDocumentModalBody">
                <StyledAlertWrapper>
                    <AlertInfo id="dmi.applicantVerifications.alert.deleteFile" />
                </StyledAlertWrapper>
            </Modal.Body>
            <Modal.Controls>
                <StyledButton>
                    <GIButton
                        id="cancel-button-document-modal"
                        onClickHandler={onClose}
                        variant="secondary"
                        labelId="button.cancel"
                    />
                    <GIButton
                        id="delete-button-document-modal"
                        onClickHandler={onDeleteHandler}
                        variant="primary"
                        labelId="dmi.button.delete"
                    />
                </StyledButton>
            </Modal.Controls>
        </Modal>
    );
}
